import { useCartRecovery } from './useCartRecovery'
import { CartRecoveryModal } from '../CartRecoveryModal'

export const CartRecovery = () => {
  const {
    showModal,
    recoveryData,
    handleAcceptRecovery,
    handleRejectRecovery
  } = useCartRecovery()

  return (
    <CartRecoveryModal
      open={showModal}
      recoveryData={recoveryData}
      onAccept={handleAcceptRecovery}
      onReject={handleRejectRecovery}
    />
  )
}
